import React, { useState } from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  Link,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core'

import useStyles from './styles'
import constants from 'constants/index'

const PermissionsReminderDialog = ({ open, onClose, onProceed }) => {
  const classes = useStyles()
  const [selected, setSelected] = useState('')

  const handleClose = () => {
    setSelected('')
    if (onClose) onClose()
  }

  const handleProceed = () => {
    if (onProceed) onProceed(selected)
    handleClose()
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle disableTypography>
        <div className={classes.dialogTitleContainer}>
          <Typography variant="h6">
            Não se esqueça da lista de permissões
          </Typography>
        </div>
      </DialogTitle>

      <Divider />

      <DialogContent>
        <Typography variant="body2" className={classes.paragraph}>
          Plataformas de treinamento em segurança exigem a adição à lista de
          permissões para garantir a entrega dos e-mails. Sem isso, seu provedor
          pode bloquear nossos e-mails de phishing simulado ou de treinamento.
        </Typography>

        <Typography variant="body2" className={classes.paragraph}>
          Veja os guias abaixo para configurar a lista de permissões em poucos
          passos!
        </Typography>

        <Box className={classes.linkList}>
          {constants.phishing.ALLOWLIST_GUIDES.map(({ label, href }) => (
            <Box key={label} display="flex" alignItems="center">
              <Typography variant="body2" className={classes.bullet}>
                •
              </Typography>
              <Link
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className={classes.link}
                variant="body2"
              >
                {label}
              </Link>
            </Box>
          ))}
        </Box>

        <Divider className={classes.divider} />

        <RadioGroup
          value={selected}
          onChange={(event) => setSelected(event.target.value)}
        >
          <FormControlLabel
            value={
              constants.phishing.PERMISSIONS_REMINDER_OPTIONS.ALREADY_CONFIGURED
            }
            control={<Radio color="primary" size="small" />}
            label={
              <Typography variant="body2">
                Já configurei a lista de permissões. Não mostrar novamente.
              </Typography>
            }
            className={classes.radioLabel}
          />
          <FormControlLabel
            value={
              constants.phishing.PERMISSIONS_REMINDER_OPTIONS.PROCEED_WITHOUT
            }
            control={<Radio color="primary" size="small" />}
            label={
              <Typography variant="body2">
                Quero prosseguir sem configurar agora.
              </Typography>
            }
            className={classes.radioLabel}
          />
        </RadioGroup>
      </DialogContent>

      <DialogActions>
        <div className={classes.dialogActions}>
          <Button onClick={handleClose} variant="outlined" color="secondary">
            Voltar
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleProceed}
            disabled={!selected}
          >
            Prosseguir
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  )
}

export default PermissionsReminderDialog
